import { cn } from "@/lib/utils";
import { AuthBackLink } from "./AuthBackLink";

interface AuthPageHeaderProps {
    title: string;
    description?: React.ReactNode;
    /** Optional secondary line (e.g. organisation · role on signup). */
    secondary?: string;
    /** Extra lines below description (invite care summary). */
    extraLines?: string[];
    backTo?: {
        label: string;
        onClick: () => void;
    };
    className?: string;
}

export function AuthPageHeader({ title, description, secondary, extraLines, backTo, className }: AuthPageHeaderProps) {
    return (
        <div className={cn("flex flex-col gap-4 w-full", className)}>
            {backTo ? <AuthBackLink label={backTo.label} onClick={backTo.onClick} /> : null}
            <div className="flex flex-col gap-1.5 w-full text-left">
                <h1 className="font-semibold text-foreground text-xl sm:text-2xl tracking-tight">{title}</h1>
                {secondary ? <p className="font-medium text-muted-foreground text-base">{secondary}</p> : null}
                {description ? <p className="text-muted-foreground text-sm leading-relaxed">{description}</p> : null}
                {extraLines?.map((line) => (
                    <p key={line} className="text-muted-foreground text-sm leading-relaxed">
                        {line}
                    </p>
                ))}
            </div>
        </div>
    );
}
